var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "200px",
    viewBox: "0 0 358 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L352,0 C355.313708,-6.08718376e-16 358,2.6862915 358,6 L358,200 L358,200 L0,200 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9517939,0.0643082741 L25.6904111,0.0643082741 C26.3660502,0.0643082741 26.913764,0.60314908 26.913764,1.2678429 L26.913764,4.57756312 C31.3993913,10.1439108 33.642205,15.7102584 33.642205,21.276606 C33.642205,26.6715109 31.7269463,32.0664157 27.896429,37.4613205 C27.6675817,37.7836241 27.2931485,37.975649 26.8935237,37.975649 L6.748676,37.975649 C6.34905097,37.975649 5.97461756,37.7836214 5.74577265,37.4613159 C1.91525755,32.0664126 0,26.6715093 0,21.276606 C0,15.8152838 2.15897762,10.3539616 6.47693287,4.8926394 L6.72844099,4.57756312 L6.72844099,1.2678429 C6.72844099,0.60314908 7.27615474,0.0643082741 7.9517939,0.0643082741 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.5506266%",
    y1: "102.348422%",
    x2: "37.5506266%",
    y2: "13.4066029%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#752E73",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.1409215%",
    y1: "69.5178093%",
    x2: "51.8973175%",
    y2: "4.7798907%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#752E73",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.1464043%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.5707793%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.6622178%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.1889984%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "-8.51259144%",
    x2: "50%",
    y2: "80.7212586%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Knowledge-Base",
    transform: "translate(-670.000000, -445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(670.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Coffe-Break",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(0.500000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9793783,58.2341343 C30.3457527,43.9908717 36.1295112,29.3627805 41.4243368,14.4117401 C29.2281594,25.7800147 19.7440494,39.6299095 21.094578,58.2341343 L23.9793783,58.2341343 Z",
    id: "Path-113",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5861446,59.72149 C19.079344,35.4349795 19.7178446,12.879603 32.3470116,0 C30.6050123,26.6653355 27.3463842,45.4498771 23.2192603,59.72149 L20.5861446,59.72149 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0066999,57.1923582 C12.950821,40.2208659 5.86072321,35.3560185 2.45563569e-14,17.9350541 C19.1807249,27.7711831 20.3830768,35.8932679 24.1479585,57.1923582 L20.0066999,57.1923582 Z",
    id: "Path-112",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.209218,57.1923582 L3.55146345,40.2208659 C9.66463154,41.944202 19.8826357,44.7348338 19.8826357,57.1923582 L16.209218,57.1923582 Z",
    id: "Path-114",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0478916,57.1923582 L32.2705097,57.1923582 C34.9538941,51.6512856 38.7353194,47.8367191 47.8835909,52.4607212 C41.8869707,43.4274953 29.5831436,40.6937123 28.0478916,57.1923582 Z",
    id: "Path-116",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1637103,57.1923582 L27.6751525,57.1923582 C34.1197035,48.0779082 36.8905412,44.1064703 43.5597821,36.3229372 C34.7741294,39.6199247 25.7558934,44.1064703 24.1637103,57.1923582 Z",
    id: "Path-117",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(7.384615, 55.812500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#7367F0",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.28173518,-0.977871883 L11.6218526,-0.977871883 C4.00803723,16.4583352 19.0267352,26.7841096 11.6218526,44.1546766 L-4.28173518,44.1546766 L-4.28173518,-0.977871883 Z",
    id: "Rectangle",
    fill: "#857AF9",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Men4.4",
    transform: "translate(52.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(39.532390, 32.458418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8512598,12.5174447 C34.8512598,12.5174447 34.7888954,8.58479687 36.3596994,6.26032361 C37.9305034,3.93585035 37.9928679,1.46675007 39.1816898,1.54757105 C40.3705117,1.62839203 39.1933831,7.36745503 39.1933831,7.36745503 C39.1933831,7.36745503 40.7018227,6.79668102 41.7854046,6.07470605 C42.8689865,5.35273107 46.1548123,1.79351432 46.9226743,2.42422733 C48.2245317,3.49887567 46.1275279,9.56083589 44.9854793,10.7727639 C43.8395329,11.9850786 37.5797035,15.9716024 37.5797035,15.9716024 C25.1063997,27.306288 18.0895122,32.9303794 16.5290411,32.8438765 C14.96857,32.7573737 11.4689476,28.1816797 6.03017401,19.1167945 L14.499606,14.3773586 L18.8697478,22.0196041 L34.8512598,12.5174447 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935468223,10.3674103 C2.1417211,13.1385574 3.81896869,16.9995556 5.45932957,20.6497858 C7.31017724,24.7684041 17.1298141,18.6860982 15.2991688,14.4401274 C13.6530213,10.6220777 11.6067117,6.11310161 9.77163593,2.75785543 C6.41495894,-3.37317905 -2.97235806,1.401195 0.935468223,10.3674103 Z",
    id: "Path",
    fill: "#655AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9193741,11.2976082 C14.2198797,11.9688621 14.5138525,12.63456 14.7985183,13.2863317 C12.3505408,16.8311751 8.66443369,18.9137814 4.94114214,19.4934071 L4.17945244,17.7785615 L4.17945244,17.7785615 C7.74883672,17.3752815 11.547932,15.337985 13.795035,11.5132229 L13.9193741,11.2976082 Z",
    id: "Path",
    fill: "#EEDFE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(23.195554, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.51047969,27.0606496 C2.51047969,27.0606496 5.60590234,26.3408805 5.71328756,21.3171514 C5.82067278,16.2934223 5.74528978,14.5785782 5.74528978,14.5785782 L13.0837537,14.4567183 C13.0837537,14.4567183 13.1578301,20.0555839 13.1591367,22.0807132 C13.1619814,26.4895074 16.4676938,28.1959348 16.4676938,28.1959348 C16.4676938,28.1959348 16.1929469,32.5013989 10.0147411,32.8454947 C5.19094026,33.1145728 2.51047969,27.0606496 2.51047969,27.0606496 Z",
    id: "Path",
    fill: "#F8C9C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head1",
    transform: "translate(0.305100, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76636489,12.039192 C1.72473195,11.922615 2.22085762,16.3329489 5.38054319,16.3269616 C5.38054319,16.3269616 8.77625667,23.0897674 14.1074565,23.1073389 C16.6754566,23.115768 17.5139147,20.8500887 18.2837458,19.2595699 C19.0535769,17.6690511 19.6185938,15.2899646 19.6655304,13.8332804 C19.7160228,12.2800944 19.7224232,7.17747328 19.7224232,7.17747328 L11.8470438,3.56748298 L4.64795668,7.17078155 L4.76636489,12.039192 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.974483,20.4457608 C14.4537631,20.6446455 14.9869406,20.526983 15.3851332,20.2974955",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(14.679808, 20.422275) rotate(6.000000) translate(-14.679808, -20.422275) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91188821,7.66141435 C2.86703783,6.92551995 4.62140881,5.25233388 6.95576479,2.43345148 C9.29012076,-0.385430926 11.1714115,-0.348102949 12.7803755,0.649087287 C14.3888069,1.64627752 22.3306561,-2.08118758 21.7176414,4.85115096 C21.104094,11.7888221 19.6720238,12.135439 19.6720238,12.135439 C19.6720238,12.135439 19.6857425,8.05397826 18.6161149,8.17662733 C17.038553,8.35751877 17.1091125,9.17177144 15.7744339,8.80382424 C14.4392228,8.43587704 11.4156912,5.48696688 10.4202745,7.87062482 C9.42485784,10.2542828 7.98419325,14.56709 7.14216341,14.4231107 C6.29960097,14.2737988 6.39419361,12.6149688 5.02432123,12.135439 C4.24993514,11.8643618 3.21203759,12.5529028 3.21203759,12.5529028 C3.21203759,12.5529028 -1.043794,8.39197618 0.91188821,7.66141435 Z",
    id: "Path",
    fill: "#9E5229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1662029,18.8038051 C13.1662029,18.8038051 14.2404212,20.1322842 16.2811309,19.541241",
    id: "Path",
    stroke: "#DE6767",
    strokeLinecap: "round",
    transform: "translate(14.723667, 19.248295) rotate(-15.000000) translate(-14.723667, -19.248295) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0724778,14.6322784 C5.26209012,13.9499917 5.17617903,13.3535373 4.49177583,13.0796654",
    id: "Path-8",
    stroke: "#DE6767",
    strokeLinecap: "round",
    transform: "translate(4.825920, 13.855972) rotate(-13.000000) translate(-4.825920, -13.855972) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(27.375474, 68.805507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C0,0 5.19004845,56.2784649 5.35148185,60.1906622 C5.51291526,64.1028596 3.68452192,70.8544641 3.72007994,78.1724003 C3.75563796,85.4903366 3.74497056,102.601093 4.38785954,109.220976 C4.8031772,113.500514 15.1402489,113.032898 15.8368305,109.459514 C16.972198,103.635594 20.6485416,64.9132634 20.7004563,57.9242786 C20.7520154,50.9352937 21.1932905,0.672695075 21.1932905,0.672695075 L0,0 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25256717,61.9424729 L8.26521481,62.0817115 C8.43756987,64.4674457 6.93299337,72.3168253 3.7514853,85.6298504 L3.72007994,78.1724003 L3.72007994,78.1724003 C3.68515689,70.9851415 5.44820987,64.3441689 5.35824848,60.4029476 L5.35148185,60.1906622 C5.2970788,58.8722517 4.67158096,51.6066566 3.86608472,42.5520098 L4.2420526,43.8781383 C6.4494909,51.7330586 7.78629005,57.7546594 8.25256717,61.9424729 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(17.340756, 60.867237) rotate(3.000000) translate(-17.340756, -60.867237) ",
    cx: 17.3407563,
    cy: 60.8672366,
    rx: 2.54873322,
    ry: 4.32790313
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(7.802445, 68.523327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0374351,0.739230365 C10.0374351,0.739230365 6.42677224,39.3540912 6.47584231,46.7488062 C6.52491237,54.1438735 7.5870304,57.3914763 6.07545901,62.696258 C4.56353205,68.0010398 3.18229692,103.969941 3.27429987,108.797455 C3.36483189,113.547787 14.102377,113.270903 14.4534363,110.012332 C15.1250971,103.7779 21.5952136,66.2495673 22.3718007,59.9677927 C23.1483878,53.6860182 32.7469195,0.206357251 32.7469195,0.206357251 L10.0374351,0.739230365 Z",
    id: "Path",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0567754,26.9477036 L12.374922,29.3986521 C10.3783493,36.6318942 8.53545352,44.2810767 9.01786304,55.2078098 L9.04139975,55.7067467 C9.1601849,58.0737074 7.64369277,71.8107082 4.49192334,96.9177493 L4.19213547,98.6823669 C3.88298218,100.482094 3.60781433,102.017719 3.36663191,103.289243 L3.43513164,101.065557 C3.83701354,88.7922462 4.91793466,66.7575747 6.07545901,62.696258 C7.5870304,57.3914763 6.52491237,54.1438735 6.47584231,46.7488062 C6.44149326,41.5725057 8.20041334,21.0983337 9.2588568,9.2796976 L10.0374351,0.739230365 L14.7563453,0.62866574 L14.7677548,1.94409449 C14.8509057,14.0854709 14.2805793,22.4200073 13.0567754,26.9477036 L13.0567754,26.9477036 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(18.209584, 60.512445) rotate(5.000000) translate(-18.209584, -60.512445) ",
    cx: 18.2095838,
    cy: 60.5124449,
    rx: 2.91270503,
    ry: 4.68878094
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(14.044402, 26.791075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8674034,0.656192364 C24.8674034,0.656192364 33.1417434,4.66214091 33.8502724,7.01173292 C34.5588014,9.36132493 36.9315744,55.4535466 36.9315744,55.4535466 C25.2562953,60.7930474 13.4696758,61.2587323 1.5605288,56.3690408 C1.5605288,56.3690408 -0.547292437,7.12286227 0.819156326,4.9479021 C1.92296991,3.18570809 12.1453126,0 12.1453126,0 L20.4675982,5.34479264 L24.8674034,0.656192364 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86270822,12.4889223 C7.39898991,13.4347119 7.12253876,16.7114582 6.03335477,22.3191612 C5.10541955,27.0966691 6.16640645,32.038825 8.96773281,36.0258701 L9.12515094,36.2463829 C10.0725022,37.5526114 10.9458518,39.2724856 11.7451996,41.4060057 C13.7230992,46.6851698 9.10309126,51.0781034 12.7431389,59.4054608 C9.02781013,58.9118613 5.30021051,57.90449 1.5605288,56.3690408 L1.33830748,50.8729049 C0.943671082,40.7400256 0.18120815,19.2750935 0.395687097,9.6817051 L0.879786951,9.77161064 C4.20510495,10.4135082 6.19942191,11.3191467 6.86270822,12.4889223 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1453126,0 L20.4675982,5.34479264 L24.8674034,0.656192364 L25.4959859,0.970104436 C25.7469588,1.09772182 26.0625294,1.26050808 26.4231056,1.45145971 L20.8647359,7.72819473 L10.2368933,0.613229022 L11.0337917,0.349800327 C11.713494,0.129289154 12.1453126,0 12.1453126,0 Z",
    id: "Path",
    fill: "#EEDFE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 30.397566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.528314,22.2364766 C26.528314,22.2364766 31.7393617,17.6682767 33.3345803,17.1381428 C34.929799,16.6080089 44.2726599,15.9711521 44.2138567,17.1690769 C44.1466179,18.4524573 39.1285721,18.378602 38.6086489,19.0100452 C38.0887258,19.6411018 37.4503985,24.471628 35.4849315,24.9561341 C33.5234034,25.4406401 28.6830838,26.2758621 28.6830838,26.2758621 C13.5975281,36.3834491 4.25002891,39.2905219 0.640586133,34.9970803 C-0.798539482,33.2852367 1.2957732,26.7716731 6.92352417,15.4563895 L18.267663,15.4563895 L10.6127555,27.9494853 L26.528314,22.2364766 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6648731,2.89445792 C9.63104392,6.7684211 6.75861077,11.9708515 4.42623261,16.7597341 C2.13793476,21.4581102 13.1169856,25.0540247 14.7157113,22.2110279 C17.3674557,17.4954593 21.5347236,9.96122446 22.1837548,8.71027665 C25.3910881,2.52958248 17.7513598,-3.60058877 12.6648731,2.89445792 Z",
    id: "Path",
    fill: "#655AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5168867,18.5799616 L16.7635789,18.5509165 L15.7061497,20.4448556 L15.7061497,20.4448556 C11.4353447,20.5937816 8.05893803,18.6268837 5.42308671,14.755489 C5.73686421,14.1378035 6.0584174,13.5176034 6.38703858,12.8981757 C8.94545968,17.1313442 12.1881795,19.0451167 16.5168867,18.5799616 L16.5168867,18.5799616 Z",
    id: "Path",
    fill: "#EEDFE8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(31.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(4.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#91D6FF",
    points: "53.0897863 2.58268657 61.8111853 2.58268657 61.8111853 78.5710647 53.0897863 78.5710647"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#E3F4FF",
    points: "53.0897863 -2.427296e-13 58.3226257 -2.427296e-13 58.3226257 78.5710647 53.0897863 78.5710647"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "2.39646776e-14 2.58268657 43.1709253 2.58268657 43.1709253 17.1757392 8.72139905 17.1757392 8.72139905 102.655642 0 102.655642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "9.80718986e-14 2.58268657 5.23283943 2.58268657 5.23283943 102.655642 8.81955466e-14 102.655642"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "184.451451 2.58268657 193.147922 2.58268657 193.147922 102.655642 184.451451 102.655642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "184.020078 -2.427296e-13 189.237961 -2.427296e-13 189.237961 102.655642 184.020078 102.655642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "123.317333 2.58268657 187.93349 2.58268657 187.93349 102.318306 132.013804 102.655642 123.317333 102.655642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "10.8705882 -1.91433929e-13 124.621804 -2.75266377e-13 124.621804 102.782726 10.8705882 102.782726"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "122.012863 2.58268657 127.230745 2.58268657 127.230745 102.782726 122.012863 102.782726"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "123.317333 2.58268657 128.535216 2.58268657 128.535216 102.655642 123.317333 102.655642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.951363,0 L194.060402,0 C196.199969,6.21655142e-15 197.934431,1.73446224 197.934431,3.87402985 C197.934431,6.01359746 196.199969,7.7480597 194.060402,7.7480597 L128.951363,7.7480597 C126.811796,7.7480597 125.077333,6.01359746 125.077333,3.87402985 C125.077333,1.73446224 126.811796,3.93032193e-16 128.951363,0 Z",
    id: "Rectangle",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "9.56611765 1.54961194 123.317333 1.54961194 123.317333 9.29767164 9.56611765 9.29767164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87402985,0 L129.009421,0 C131.148989,1.32702242e-14 132.883451,1.73446224 132.883451,3.87402985 C132.883451,6.01359746 131.148989,7.7480597 129.009421,7.7480597 L3.87402985,7.7480597 C1.73446224,7.7480597 2.62021462e-16,6.01359746 0,3.87402985 C-2.62021462e-16,1.73446224 1.73446224,-5.10570166e-17 3.87402985,0 Z",
    id: "Rectangle",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cup",
    transform: "translate(108.500000, 75.500000) scale(-1, 1) translate(-108.500000, -75.500000) translate(101.500000, 71.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63697926,1.07311393 L0.942307692,1.07311393 C0.421885524,1.07311393 0,1.51383363 0,2.05748893 L0,3.40582458 C0,4.6941451 0.999758076,5.73853523 2.23302216,5.73853523 L3.63697926,5.73853523 C3.86001733,5.73853523 4.04082541,5.54965536 4.04082541,5.31666023 C4.04082541,5.0836651 3.86001733,4.89478523 3.63697926,4.89478523 L2.23302216,4.89478523 C1.44583422,4.89478523 0.807692308,4.22815484 0.807692308,3.40582458 L0.807692308,2.05748893 C0.807692308,1.97982389 0.867961668,1.91686393 0.942307692,1.91686393 L3.63697926,1.91686393 C3.86001733,1.91686393 4.04082541,1.72798406 4.04082541,1.49498893 C4.04082541,1.2619938 3.86001733,1.07311393 3.63697926,1.07311393 Z",
    id: "Path",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5851646,0 C13.1799328,0 13.6620877,0.503679656 13.6620877,1.125 L13.6620877,3.9375 C13.6620877,5.96246111 12.1988302,7.63040288 10.3166279,7.85039153 L10.3161748,8.4375 L5.60214915,8.4375 L5.60189523,7.83758499 C3.76712576,7.57219369 2.35439534,5.92719248 2.35439534,3.9375 L2.35439534,1.125 C2.35439534,0.503679656 2.83655023,0 3.43131842,0 L12.5851646,0 Z",
    id: "Path",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43509615,7.875 L13.1802885,7.875 C13.3356185,7.875 13.4615385,8.00091991 13.4615385,8.15625 C13.4615385,8.31463582 13.3389694,8.44601124 13.1809641,8.4569832 L9.23710817,8.73084624 L9.23710817,8.73084624 L6.41018509,8.73084624 L2.43443056,8.45683784 C2.27644163,8.44594926 2.15384615,8.31461371 2.15384615,8.15625 C2.15384615,8.00091991 2.27976607,7.875 2.43509615,7.875 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.8",
    transform: "translate(118.500000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(54.047239, 29.005076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0094361,31.1764694 C10.0094361,31.1764694 4.4678192,36.1493087 4.85046679,36.6913138 C5.23349345,37.2368835 8.07953712,35.7841874 8.07953712,35.7841874 C8.07953712,35.7841874 4.75009406,41.9737272 5.52105488,42.398323 C6.29163863,42.8229186 10.0669575,41.6986673 11.1763191,40.4018373 C12.2860577,39.1050075 13.8050308,33.2815933 13.8050308,33.2815933 L20.9904148,22.2470007 L15.1343271,19.6692446 L10.0094361,31.1764694 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    transform: "translate(12.910970, 31.079390) rotate(28.866471) translate(-12.910970, -31.079390) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2573776,8.26789373 C12.6871002,11.2671699 20.9717327,20.42869 20.9717327,20.42869 C20.9717327,20.42869 20.4266023,20.8347559 19.3363415,21.6468879 L24.6550103,28.0509222 C26.9191792,26.6738325 28.4279191,25.7614422 29.1812302,25.3137514 C33.2135359,22.9173628 31.6707642,19.048266 28.6873915,15.5178262 C26.3957007,12.8059034 21.4136154,7.25008655 17.908419,2.37283855 C14.4208412,-2.47989427 5.54247897,2.4477713 10.2573776,8.26789373 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9717327,20.42869 C22.5266578,21.9272344 23.2233021,22.7345106 23.0616657,22.8505187 C22.9000293,22.9665267 21.8823771,22.389641 20.0087091,21.1198614 L20.9717327,20.42869 Z",
    id: "Path-15",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-76",
    fill: "#FFEDC2",
    points: "19.6658098 20.9768856 26.5979821 27.7893533 23.131896 30.040972 18.3701194 21.9487686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(52.237852, 101.940900) scale(-1, 1) translate(-52.237852, -101.940900) translate(29.737852, 70.440900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6530432,41.2223723 L28.3751715,53.3108894 L22.1186653,53.5940713 C22.1186653,53.5940713 23.0005421,49.4590067 21.7415869,45.5827643 C20.73199,42.4708086 19.9078914,40.9178756 19.9078914,40.9178756 L24.6530432,41.2223723 Z",
    id: "Path",
    fill: "url(#linearGradient-8)",
    transform: "translate(24.141531, 47.255973) scale(-1, 1) translate(-24.141531, -47.255973) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5707705,50.0849282 C26.5707705,50.0849282 26.2256354,53.146267 27.2214275,54.1908684 C28.2167592,55.2350234 33.6065285,59.2110581 34.0286642,59.9655197 C34.4507998,60.7204277 33.6956351,61.5531262 33.6956351,61.5531262 C33.6956351,61.5531262 27.8735811,62.0608278 25.2553204,60.4659026 C23.3649426,59.3137889 22.0217378,58.3868188 22.0217378,58.3868188 L21.3108806,59.9046735 L18.1984587,59.2294053 C18.1984587,59.2294053 17.4022876,56.686532 17.9047157,55.4846427 C18.4071439,54.2823069 20.9582126,48.6810522 20.9582126,48.6810522 C20.9582126,48.6810522 22.8290652,49.1490108 26.5707705,50.0849282 Z",
    id: "Path",
    fill: "#391B0B",
    transform: "translate(25.947660, 55.155501) rotate(-4.000000) translate(-25.947660, -55.155501) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42529865,0.0163759529 C10.1311652,0.479265658 33.3110133,6.04528303 38.0837262,7.033702 C42.8564391,8.02212096 46.8914589,13.3705263 43.2520445,19.5636837 C40.5269439,24.1984475 35.312462,33.7174843 27.6085991,48.1207941 C27.5373395,48.1381867 27.4675453,48.1692526 27.3952848,48.1692526 C25.0449053,48.1692526 22.9493131,47.8448027 20.9317963,46.4270208 C22.9755232,31.3242291 26.3768321,21.6683655 31.1357231,17.4594301 C31.1357231,17.4594301 12.7028588,24.141708 3.484371,16.8508558 C-1.95355855,12.5500266 0.239242764,-0.493747288 5.42529865,0.0163759529 Z",
    id: "Path",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2520445,19.5636837 C42.5130689,20.8205098 41.5629905,22.4954009 40.4871585,24.4224204 L41.7229488,8.7760872 C44.4997756,11.040577 45.8863981,15.0808288 43.2520445,19.5636837 Z",
    id: "Combined-Shape",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(34.547934, 100.387056) scale(-1, 1) translate(-34.547934, -100.387056) translate(0.047934, 68.887056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4294199,41.8812585 C53.4294199,41.8812585 51.3563578,51.1014171 48.6581623,52.0879863 C47.6192495,52.4678548 55.0675851,53.5526152 55.0675851,53.5526152 L57.3270143,44.7069875 L53.4294199,41.8812585 Z",
    id: "Path",
    fill: "url(#linearGradient-9)",
    transform: "translate(52.942894, 47.716937) scale(-1, 1) translate(-52.942894, -47.716937) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6969626,49.6440192 L50.8340811,61.3531802 L54.2858928,61.3550253 L54.3163735,58.4697526 C54.3163735,58.4697526 55.4045587,61.1595272 57.0685899,61.3146644 C58.7376035,61.4698005 67.1961392,61.534796 67.1961392,61.534796 C67.1961392,61.534796 67.814485,58.8334588 64.1129419,57.607734 C61.0341348,56.5888443 56.6091362,49.642814 56.6091362,49.642814 L50.6969626,49.6440192 Z",
    id: "Path",
    fill: "#391B0B",
    transform: "translate(58.965941, 55.588805) rotate(-9.000000) translate(-58.965941, -55.588805) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05081876,0.0913972859 C-1.52372884,9.76509453 -0.596640429,16.2628171 5.83208401,19.5845651 C15.1577439,24.4031713 39.9720005,18.186106 39.9720005,18.186106 C39.9720005,18.186106 39.4731326,22.2078625 39.9720005,25.7947845 C41.2749205,35.1629428 47.6823708,46.6887824 48.2652632,48.5883527 C48.558773,49.5448629 55.7051217,48.1314732 55.7051217,46.9968835 C55.7051217,45.8622937 52.0590105,20.0410309 51.4100708,14.5412124 C50.7644762,9.04105895 48.7262603,8.24214169 42.7731519,6.73863796 C41.4055084,6.39322897 23.6804883,2.3686183 22.1988822,2.48592368 C13.7119177,3.15787462 7.32922986,2.35969915 3.05081876,0.0913972859 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1988822,2.48592368 C23.6804883,2.3686183 41.4055084,6.39322897 42.7731519,6.73863796 L43.7504336,6.98908472 C48.8280078,8.3153573 50.71016,9.30490634 51.3638654,14.1734235 L51.5397527,15.5709987 C52.0756917,19.6498088 53.5239324,29.2409493 54.6695961,37.2258573 C53.3766397,34.2914344 52.3067443,31.0348875 51.4596411,27.4565952 C49.4855068,19.1175524 49.9078451,12.2702753 49.3776704,11.0711145 C48.8474958,9.87195359 22.9186376,6.04361072 18.4633631,5.25367964 C16.5240932,4.90984232 15.4301327,4.0569492 15.1814817,2.69500027 C17.3346415,2.75564115 19.6736116,2.68586065 22.1988822,2.48592368 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(48.729650, 1.744522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47955212,11.5727034 C-0.557887382,11.7958994 -0.413442045,15.3825655 2.06676042,15.5698309 C2.57368754,19.0273904 4.38153497,20.6747173 6.58561877,20.8653322 L6.4633724,26.0950622 L16.2126724,26.0892767 C16.2126724,26.0892767 13.4672987,22.3948189 13.6041417,17.3371295 C13.7409846,12.2791356 13.5123049,7.52776984 13.5123049,7.52776984 L0.88474142,7.75461984 L1.47955212,11.5727034 Z",
    id: "Path",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4325009,11.8414241 C14.0595004,10.9017602 12.3065502,14.9474571 10.4908581,17.7593344 C8.67516601,20.5712118 3.97100456,20.0934512 3.32265926,17.7593344 C0.868074077,12.6470743 -1.24722644,5.69675905 1.61717437,5.12630763 C2.02036622,-2.26230992 21.3337108,-0.517947793 16.4325009,11.8414241 Z",
    id: "Path",
    fill: "#9E5229",
    transform: "translate(8.734338, 10.215009) scale(-1, 1) translate(-8.734338, -10.215009) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4323704,2.32925829 C15.2597346,3.03308026 15.7882583,3.96733666 15.8515025,5.12630763 C18.7159033,5.69675905 16.6006028,12.6470743 14.1460176,17.7593344 C13.5430972,19.9299165 9.43277502,20.4951528 7.39960452,18.3024068 C5.54554418,12.7399439 6.33767058,6.52086399 10.0866742,2.33076507 L10.0866742,2.33076507 Z",
    id: "Combined-Shape",
    fillOpacity: 0.199355332,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FB9934",
    cx: 11.7063917,
    cy: 2.33076507,
    rx: 2.32769406,
    ry: 2.33076507
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(41.632870, 26.179528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2543001,2.67294278 C27.4293503,5.87236115 31.0543557,16.7310704 31.2599538,19.1739315 C31.4915965,21.9917797 28.4747251,26.4805547 28.4250874,30.5597942 C28.3809649,34.6395895 30.6753315,44.8516383 29.9859185,45.9991155 C29.3020208,47.1465926 6.58833709,53.7807595 5.3087865,53.2355834 C4.02923591,52.6904074 -0.388035394,46.8111274 0.621265287,44.4217077 C1.63608127,42.032288 5.82888577,36.6122499 5.3490543,33.3565267 C4.87473814,30.1013591 2.12025479,18.0848006 0.752459334,13.9950031 C-0.609820821,9.90520569 -0.155570334,5.61136411 2.38698494,3.8515287 C3.64505436,2.98075309 7.00212996,0.506873266 12.980483,0.517873917 C18.9588361,0.529555457 25.085627,2.42483089 25.2543001,2.67294278 Z",
    id: "Path",
    fill: "#FF9F43",
    transform: "translate(15.636320, 26.892619) scale(-1, 1) translate(-15.636320, -26.892619) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14212723,16.5511653 L11.5653273,9.04116502 L11.5621959,10.413572 C11.5236362,18.8834937 10.9920254,23.3703162 2.14516542,37.2512021 L2.34980797,35.8365799 C2.63816845,33.783 2.86161343,31.8599889 2.847552,30.5597942 C2.81623556,27.9862024 1.60385715,25.2496012 0.771315733,22.8724365 L1.14212723,16.5511653 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7686072,0.284221965 C12.6008753,1.20144487 12.8841431,1.66005632 13.6184104,1.66005632 C14.7198114,1.66005632 22.107462,1.90367482 23.1079177,1.46863964 C23.7748882,1.17861618 24.0083088,0.78381029 23.8081796,0.284221965 L12.7686072,0.284221965 Z",
    id: "Path-68",
    fill: "#FFF6E1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(8.527888, 27.969181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00940944,17.0182197 C9.00940944,17.0182197 2.98394986,12.9948283 1.91900104,12.1867259 C0.857521114,11.3820477 -0.474532127,5.28018949 0.351063372,4.42414878 C0.749985566,4.00982508 3.7644498,6.79709362 4.30212754,7.17032737 C4.83633639,7.54013696 7.56982065,9.18715928 7.56982065,9.18715928 C7.56982065,9.18715928 6.79625848,4.51660118 7.4622851,4.13994327 C7.95486729,3.86601024 8.94003167,5.0678914 9.07184944,6.33825581 C9.2036672,7.60862021 10.5738782,9.26591502 10.7507915,11.1937187 C10.830576,12.0360628 11.142375,13.1274715 11.142375,13.1274715 L27.8608912,20.3110074 L26.1117719,28.121768 L9.00940944,17.0182197 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8952888,9.302498 C42.5863355,14.1013652 38.6648075,21.1169681 36.5109429,25.2307178 C33.9622924,30.0984845 30.9252169,32.1609727 24.7993584,28.5488614 C24.3214079,28.2670379 23.5655104,27.8120539 22.531666,27.1839092 L26.3240943,18.7591646 C27.651166,19.3459144 28.3147018,19.6392893 28.3147018,19.6392893 C28.3147018,19.6392893 34.1811374,8.92100719 36.6169419,3.77501378 C39.7156745,-2.7655743 49.3635495,0.0157835223 44.8952888,9.302498 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3147018,19.6392893 C27.5995656,22.1585591 27.1576135,23.3684258 26.9888456,23.2688894 C26.8200777,23.1693531 26.8793297,21.7789263 27.1666018,19.0976092 L28.3147018,19.6392893 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-75",
    fill: "#FFEDC2",
    points: "26.3778957 18.3871466 23.7363869 28.8749869 19.8061719 26.7487797 24.9633849 17.570439"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.2099637,2.22023951 C67.2099637,2.22023951 65.0318742,-0.62069752 62.5167056,0.124638473 C60.001537,0.869974465 57.7264278,5.43877285 58.8066955,9.73335434 C59.8815072,14.0284921 58.9951393,16.4782552 57.6911798,19.3728287 C54.1884938,27.1593649 66.3157055,32.1033508 66.3157055,32.1033508 C65.6848849,28.2568496 65.982971,25.1722673 67.2099637,22.849604 C69.1054502,19.2615003 70.1819421,14.6602218 70.1819421,11.8445037 C70.1819421,6.94805107 67.2099637,2.22023951 67.2099637,2.22023951 Z",
    id: "Path",
    fill: "#9E5229",
    transform: "translate(63.619001, 16.051675) scale(-1, 1) translate(-63.619001, -16.051675) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cafe-Table",
    transform: "translate(166.500000, 129.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#91D6FF",
    points: "17.6986301 1.80097087 17.6986301 52.7020286 20.0074749 52.6577963 20.0410959 2.77397668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91827371,0 L33.0817263,0 C34.3605604,2.82248679e-15 35.3972603,1.03669988 35.3972603,2.31553398 C35.3972603,3.59436809 34.3605604,4.63106796 33.0817263,4.63106796 L4.91827371,4.63106796 C3.6394396,4.63106796 2.60273973,3.59436809 2.60273973,2.31553398 C2.60273973,1.03669988 3.6394396,2.34918014e-16 4.91827371,0 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11730283,3.60194175 L34.8826972,3.60194175 C35.1668825,3.60194175 35.3972603,3.8323195 35.3972603,4.11650485 C35.3972603,4.40069021 35.1668825,4.63106796 34.8826972,4.63106796 L3.11730283,4.63106796 C2.83311748,4.63106796 2.60273973,4.40069021 2.60273973,4.11650485 C2.60273973,3.8323195 2.83311748,3.60194175 3.11730283,3.60194175 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3519085,37.5631068 L28.6480915,37.5631068 C29.5006476,37.5631068 30.1917808,38.25424 30.1917808,39.1067961 C30.1917808,39.9593522 29.5006476,40.6504854 28.6480915,40.6504854 L9.3519085,40.6504854 C8.49935243,40.6504854 7.80821918,39.9593522 7.80821918,39.1067961 C7.80821918,38.25424 8.49935243,37.5631068 9.3519085,37.5631068 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.ea1e3c4f586f20f1e7d5d8dff0417315.svg";
export { ForwardRef as ReactComponent };